import React from "react";
import { Calendar } from "./date-picker";
import { TimePicker } from "./time-picker";
import "./calender.css";
import { getDateAMPM, getDateHour, getDateMinutes } from "../date";

const DateTimeInput = ({
  valueDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  },
  valueTime = `${getDateHour()}:${getDateMinutes()} ${getDateAMPM()}`,
  onChangeDate = () => {},
  onChangeTime = () => {},
  className,
}) => {
  return (
    <div className={className}>
      <Calendar
        value={valueDate}
        onChange={onChangeDate}
        shouldHighlightWeekends
      />
      <TimePicker onChange={onChangeTime} value={valueTime} use12Hours={true} />
    </div>
  );
};

export default DateTimeInput;
